import React, { useState } from "react";
import { FaUserAstronaut, FaEnvelope, FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

function InfoSection({ open }) {
  const [showAbout, setShowAbout] = useState(true);

  return (
    <div
      style={{
        position: "fixed",
        top: "200px",
        left: open ? "0" : "-340px",
        zIndex: 2000,
        width: 320,
        minHeight: 250,
        padding: "30px 18px",
        background: "linear-gradient(135deg, #fff 10%, #a993ea 120%)",
        borderRadius: "22px 7px 7px 22px",
        boxShadow: "0 4px 32px rgba(80,72,182,0.13)",
        border: "2px solid #a993ea20",
        transition: "left 0.35s cubic-bezier(.86,.01,.67,1.01), opacity 0.16s",
        opacity: open ? 1 : 0
      }}
    >
      {/* Panel toggle buttons */}
      <div style={{ display: "flex", gap: 14, marginBottom: 16, justifyContent: "center" }}>
        <button
          onClick={() => setShowAbout(true)}
          style={{
            background: showAbout ? "linear-gradient(90deg,#a993ea,#ffd700)" : "#fff",
            border: showAbout ? "2px solid #a993ea" : "2px solid #eee",
            color: showAbout ? "#fff" : "#5048b6",
            borderRadius: 18,
            fontWeight: "900",
            padding: "6px 16px",
            fontSize: "1rem",
            cursor: "pointer"
          }}>
          <FaUserAstronaut style={{marginRight:7}} /> About
        </button>
        <button
          onClick={() => setShowAbout(false)}
          style={{
            background: !showAbout ? "linear-gradient(90deg,#a993ea,#ffd700)" : "#fff",
            border: !showAbout ? "2px solid #a993ea" : "2px solid #eee",
            color: !showAbout ? "#fff" : "#5048b6",
            borderRadius: 18,
            fontWeight: "900",
            padding: "6px 16px",
            fontSize: "1rem",
            cursor: "pointer"
          }}>
          <FaEnvelope style={{marginRight:7}} /> Contact
        </button>
      </div>
      {/* Panel Content */}
      {showAbout ? (
        <div>
          <h2 style={{ color: "#5048b6", fontWeight: 900, fontSize: "1.18rem", margin: "0 0 10px 0" }}>
            About Me
          </h2>
          <p style={{ color: "#232356", fontWeight: 500, fontSize: "1.08rem", lineHeight: "1.6" }}>
            Hi, I'm Dinesh Bahadur Shahi—a Computer Science Engineer. <br />
            I love building practical, beautiful web tools that make tech feel easy for everyone.<br />
            Thanks for visiting!
          </p>
          <div style={{ 
            marginTop: 14, 
            padding: "10px", 
            background: "rgba(169,147,234,0.08)", 
            borderRadius: "12px",
            textAlign: "center"
          }}>
            <span style={{ color: "#5048b6", fontWeight: 700 }}>
              – Dinesh
            </span>
          </div>
        </div>
      ) : (
        <div>
          <h2 style={{ color: "#5048b6", fontWeight: 900, fontSize: "1.2rem", margin: "0 0 12px 0" }}>
            Let's Connect!
          </h2>
          <p style={{ color: "#232356", fontWeight: 500, fontSize: "1.05rem", lineHeight: "1.65" }}>
            I'd love to hear from you! Whether you have feedback, want to collaborate, or just want to say hi — reach out anytime! 😊
          </p>
          
          <div style={{ marginTop: 16, marginBottom: 18 }}>
            <div style={{ marginBottom: 8 }}>
              <span style={{ color: "#5048b6", fontWeight: 700 }}>📧 Email:</span><br />
              <a href="mailto:imdineshbdr@gmail.com" style={{ color: "#a993ea", fontWeight: 700, textDecoration: "none" }}>
                imdineshbdr@gmail.com
              </a>
            </div>
            <div style={{ marginBottom: 8 }}>
              <span style={{ color: "#5048b6", fontWeight: 700 }}>👤 Personal:</span><br />
              <a href="https://www.facebook.com/shahidinesh.07" target="_blank" rel="noopener noreferrer" style={{ color: "#a993ea", fontWeight: 700, textDecoration: "none" }}>
                facebook.com/shahidinesh.07
              </a>
            </div>
            <div>
              <span style={{ color: "#5048b6", fontWeight: 700 }}>🎮 Gaming Page:</span><br />
              <a href="https://www.facebook.com/mrdingamer/" target="_blank" rel="noopener noreferrer" style={{ color: "#a993ea", fontWeight: 700, textDecoration: "none" }}>
                facebook.com/mrdingamer
              </a>
            </div>
          </div>
          
          <div style={{ 
            marginTop: 16, 
            display: "flex", 
            justifyContent: "center", 
            gap: 18,
            padding: "10px",
            background: "rgba(169,147,234,0.1)",
            borderRadius: "12px"
          }}>
            <a href="https://www.facebook.com/shahidinesh.07" target="_blank" rel="noopener noreferrer" style={{ color: "#1877f2", fontSize: "1.5em" }} title="Personal Facebook">
              <FaFacebook />
            </a>
            <a href="https://www.facebook.com/mrdingamer/" target="_blank" rel="noopener noreferrer" style={{ color: "#5048b6", fontSize: "1.5em" }} title="Gaming Page">
              <FaFacebook />
            </a>
            <a href="mailto:imdineshbdr@gmail.com" style={{ color: "#a993ea", fontSize: "1.5em" }} title="Send Email">
              <FaEnvelope />
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default InfoSection;
